import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    materials: [],
    loading: false,
    error: null,
}

const handoutMaterialsSlice = createSlice({
    name: "handoutMaterials",
    initialState,
    reducers: {
        setHandoutMaterials: (state, action) => {
            state.materials = action.payload
        },
        setHandoutLoading: (state, action) => {
            state.loading = action.payload
        },
        setHandoutError: (state, action) => {
            state.error = action.payload
        },
        addHandoutMaterial: (state, action) => {
            state.materials.unshift(action.payload)
        },
        removeHandoutMaterial: (state, action) => {
            state.materials = state.materials.filter(
                material => material.id !== action.payload
            )
        },
    },
})

export const {
    setHandoutMaterials,
    setHandoutLoading,
    setHandoutError,
    addHandoutMaterial,
    removeHandoutMaterial,
} = handoutMaterialsSlice.actions

export default handoutMaterialsSlice.reducer
